import { isEmpty, isNil } from "lodash";
var locales = [
    { locale: "en-GB", currency: "GBP" },
    { locale: "en-AU", currency: "AUD" },
    { locale: "fr-FR", currency: "EUR" },
    { locale: "en-IE", currency: "EUR" }
];
export default function getCurrencyForDeal(deal) {
    var _a;
    if (!isEmpty(deal && deal.productConfig && deal.productConfig.products)) {
        return deal.productConfig.products[0].salePrice.currency;
    }
    else if (!isNil(deal && deal.locale)) {
        var item = locales.find(function (l) { return l.locale === deal.locale; });
        return ((_a = item) === null || _a === void 0 ? void 0 : _a.currency) || "";
    }
    return "";
}
export function getCurrencyForProduct(product) {
    var _a;
    var item = locales.find(function (l) { return l.locale === product.locale; });
    return ((_a = item) === null || _a === void 0 ? void 0 : _a.currency) || "";
}
